export const URLMODELS = {
  LOGIN: {
    POST_LOGIN: "login",
    POST_LOGIN_REFRESH: "login/refresh",
    GET_ME: "profile",
  },

  USUARIOS: {
    GET_USUARIOS: "usuarios",
    GET_USUARIOS_AGENTES: "usuarios",
    GET_PERFIS: "usuarios/perfis",
    GET_ASSOCIAR: "associar",
    GET_DESASSOCIAR: "desassociar",
    GET_ATIVAR: "ativar",
    GET_DESATIVAR: "desativar",
    GET_USUARIOS_CPF: "usuarios/cpf",
    PUT_USUARIOS: "usuarios",
    POST_ALTERAR_SENHA: "usuarios/alterar-senha",
    POST_RESET_SENHA: "usuarios/resetar-senha",
  },

  PERFIS: {
    GET_PERFIS: "perfis",
    GET_PERMISSOES: "permissoes",
    GET_ASSOCIAR_USUARIO: "usuarios/associar",
    GET_DESASSOCIAR_USUARIO: "usuarios/desassociar",
    GET_ASSOCIAR_PERMISSOES: "perfis/associar",
    GET_DESASSOCIAR_PERMISSOES: "perfis/desassociar",
  },

  PERMISSOES: {
    GET_PERMISSOES: "permissoes",
  },

  PERFIS_PERMISSOES: {
    GET_PERFIS_PERMISSOES: "perfis-permissoes",
    GET_PERFIS_PERMISSOES_PERFIL_ID: "perfis-permissoes/perfil-id",
  },

  AGENTES: {
    GET_AGENTES: "agentes",
    GET_AGENTES_CONTAGEM: "agentes/contagem",
    GET_AGENTES_CONTAGEM_POR_UNIDADE: "agentes/contagem-por-unidades",
    GET_AGENTES_FILTRADOS: "agentes/filtrados",
    GET_AGENTES_FILTRADOS_STATUS_UNIDADE: "agentes/filtro-status-unidades",
    PUT_AGENTES: "agentes",
    GET_AGENTES_VEICULOS: "agentes/veiculos",
    GET_AGENTES_TELEMETRIAS: "agentes/telemetrias",
    GET_AGENTES_USUARIOS: "agentes/usuarios",
    GET_AGENTES_POR_MATRICULA: "agentes/matriculas",
    POST_AGENTES_POR_MATRICULA: "agentes/matriculas-seg",
    GET_AGENTES_POR_ID: "agentes/id",
    GET_FOTO_AGENTE_ID: "foto-agente-por-id",
    GET_FOTO_AGENTE_ID_FRONT: "foto-agente-por-id-front",
    POST_BOTAO_PANICO: "agentes/botao-panico",
    POST_DESLOGAR_AGENTE: "agentes/deslogar-agente",
    POST_FECHAR_PRONTO_AGENTE: "agentes/fechar-pronto-agente",
    GET_PAINEL_AGENTES_PANICO: "agentes/painel-agentes-panico",
    GET_AGENTES_PANICO: "agentes/agentes-panico",
    POST_AGENTES_POR_CHAVE: "agentes/por-chave",
    POST_AGENTES_FILTRADOS_STATUS_UNIDADE: "agentes/filtro-status-unidades",
  },

  TELEMETRIAS: {
    GET_TELEMETRIAS: "telemetrias",
  },

  TELEMETRIA_STATUS_TIPOS: {
    GET_TELEMETRIA_STATUS_TIPOS: "telemetria-status-tipo",
  },

  TIPOS_MOVIMENTACOES_AGENTES: {
    GET_TIPOS_MOVIMENTACOES_AGENTES: "tipos-movimentacoes-agentes",
  },

  AGENTES_VEICULOS: {
    GET_AGENTES_VEICULOS: "agentes-veiculos",
  },

  AGENTES_EQUIPAMENTOS: {
    GET_AGENTES_EQUIPAMENTOS: "agentes-equipamentos",
  },

  EQUIPAMENTOS: {
    GET_EQUIPAMENTOS: "equipamentos",
  },

  ANDAMENTOS: {
    GET_ANDAMENTOS: "andamentos",
    GET_ANDAMENTOS_FILTROS: "andamentos/filtros",
    GET_ANDAMENTOS_TIPOS: "andamentos-tipos",
    GET_ANDAMENTOS_FECHAMENTOS_TIPOS: "andamentos-fechamentos-tipos",
    GET_ANDAMENTOS_FECHAMENTOS_MOTIVOS: "andamentos-fechamentos-motivos",
  },

  ANDAMENTOS_ENVOLVIDOS: {
    GET_ANDAMENTOS_ENVOLVIDOS: "andamentos-envolvidos",
    GET_ANDAMENTOS_ENVOLVIDOS_TIPO: "andamentos-envolvidos/tipos",
  },

  SOLICITACAO_ENVOLVIDOS: {
    POST_ANDAMENTOS_ENVOLVIDOS: "solicitacoes-envolvidos",
    GET_SOLICITACAO_ENVOLVIDOS_TIPOS: "solicitacoes-envolvidos-tipos",
  },

  ANDAMENTOS_FOTOS: {
    GET_ANDAMENTOS_FOTOS: "andamentos-fotos",
  },

  ANDAMENTOS_TIPOS: {
    GET_ANDAMENTOS_TIPOS: "andamentos-tipos",
    GET_ANDAMENTOS_TIPOS_FILTRO_MAPA: "andamentos-tipos/filtro-mapa",
  },

  ANDAMENTOS_FECHAMENTOS_TIPOS: {
    GET_ANDAMENTOS_FECHAMENTOS_TIPOS: "andamentos-fechamentos-tipos",
  },

  ANDAMENTOS_FECHAMENTOS_MOTIVOS: {
    GET_ANDAMENTOS_FECHAMENTOS_MOTIVOS: "andamentos-fechamentos-motivos",
  },

  DESPACHOS: {
    GET_DESPACHOS: "despachos",

    POST_DESPACHOS: "despachos",
  },

  DESPACHOS_TIPOS: {
    GET_DESPACHOS_TIPOS: "despachos-tipos",
  },

  PROVIDENCIAS_TIPOS: {
    GET_PROVIDENCIAS_TIPOS: "providencias-tipos",
  },

  PAPELETAS: {
    GET_PAPELETAS_ULTIMA: "papeletas/supervisoes-agente-ultima",
  },

  ANDAMENTOS_VEICULOS: {
    GET_ANDAMENTOS_VEICULOS: "andamentos-veiculos",
  },

  ORGAOS: {
    GET_ORGAOS: "orgaos",
    GET_ORGAOS_UNIDADES: "orgaos/unidades",
    GET_ORGAOS_PERFIS: "orgaos/perfis",
  },

  POLIGONOS: {
    GET_POLIGONOS_PATHS: "poligonos/paths",
  },

  UNIDADES: {
    GET_UNIDADES: "unidades",
    GET_UNIDADES_ORGAOS: "unidades/orgaos",
    GET_UNIDADES_ENDERECOS: "unidades/enderecos",
    GET_UNIDADES_FILTRO: "unidades/filtro",
    GET_UNIDADES_USUARIOS: "unidades/usuarios",
    GET_UNIDADES_VEICULOS: "unidades/veiculos",
    GET_UNIDADES_ASSOCIAR: "unidades/associar",
    GET_UNIDADES_DESASSOCIAR: "unidades/desassociar",
    GET_UNIDADES_LISTAR_POR_USUARIO: "user-unidades/listar-unidades-usuario",
    POST_ASSOCIAR_UNIDADES_USUARIO: "user-unidades/associar-unidades",
  },

  ENDERECOS: {
    GET_ENDERECOS: "enderecos",
    GET_ENDERECOS_UNIDADES: "enderecos/unidades",
  },

  SUPERVISAO: {
    GET_SUPERVISOES: "supervisoes",
    GET_SUPERVISOES_CONTAGEM: "supervisoes/contagem",
    POST_SUPERVISOES_FILTROS: "supervisoes/filtros",
    POST_SUPERVISOES_FILTROS_PAGINATE: "supervisoes/filtros-paginate",
  },
  SOLICITACOES: {
    GET_SOLICITACOES: "solicitacoes",
    GET_SOLICITACOES_FILTRO_INICIAL: "solicitacoes/filtro-inicial",
    GET_SOLICITACOES_POR_DATA:
      "solicitacoes/data-inicio/{data-inicio}/data-fim/{data-fim}",
    GET_SOLICITACOES_ANDAMENTOS: "solicitacoes/andamentos",
    GET_SOLICITACOES_ENVOLVIDOS: "solicitacoes/solicitacoes-envolvidos",
    GET_SOLICITACAOPORPROTOCOLO: "solicitacoes/protocolos",
    GET_SOLICITACOES_ORIGENS: "solicitacoes/origens",
    GET_SOLICITACOES_COM_ANDAMENTOS_E_DESPACHO:
      "solicitacoes/andamentos/despachos",
    GET_SOLICITACOES_COM_ANDAMENTOS_E_DESPACHO_POR_ID: "solicitacoes",
    GET_SOLICITACOES_COM_ANDAMENTOS_E_DESPACHO_POR_PROTOCOLO:
      "solicitacoes/protocolo",
      GET_SOLICITACOES_FORM_LATERAL_POR_PROTOCOLO:
      "solicitacoes/protocolo",
    POST_SOLICITACOES_FILTRO_SOLICITACOES: "solicitacoes/filtro-solicitacoes",
    GET_SOLICITACOES_SYNC_STATUS: "solicitacoes/sync-status",
  },

  SOLICITACOES_TIPOS: {
    GET_SOLICITACOES_TIPOS: "solicitacoes-tipos",
    GET_SOLICITACOES_TIPOS_SUBTIPOS: "solicitacoes-tipos/solicitacoes-subtipos",
  },

  SOLICITACOES_FOTOS: {
    GET_SOLICITACOES_FOTOS: "solicitacoes-fotos",
    POST_SOLICITACOES_FOTOS: "solicitacoes-fotos",
  },

  SOLICITACOES_SUBTIPOS: {
    GET_SOLICITACOES_SUBTIPOS: "solicitacoes-subtipos",
    GET_SOLICITACOES_SUBTIPOS_SOLICITACOES_TIPOS:
      "solicitacoes-subtipos/solicitacoes-tipos",
  },

  TRO: {
    GET_LISTAR_GRUPO_TIPO_OCORRENCIA: "tro/listar-grupo-tipo-ocorrencia",
    GET_LISTAR_SUBGRUPO_TIPO_OCORRENCIA: "tro/listar-subgrupo-tipo-ocorrencia",
    GET_TROS: "tro/listar-markers-tro",
    GET_TRO: "tro/mostrar-tro",
    POST_TRO: "tro/salvar-tro",
    PUT_TRO: "tro/atualizar-tro",
    DELETE_TRO: "tro/deletar-tro",
    GET_TRO_ID: "tro/get-tro-idocorrencia",
    GET_LISTAR_TROS: "tro/listar-tro",
    GET_CONTAGEM_TROS: "tro/listar-ocorrencias-status-avaliacao-por-permisao",
    POST_TROS_FILTRADOS: "tro/listar-ocorrencias-filtros",
    POST_TRO_AVALIAR: "tro/avaliar-tro",
    POST_TRO_DESATIVAR: "tro/listar-ocorrencias-filtros",
  },

  ORIGENS: {
    GET_ORIGENS: "origens",
    GET_ORIGENS_SOLICITACOES: "origens/solicitacoes",
  },

  VEICULOS: {
    GET_VEICULOS: "veiculos",
    GET_VEICULOS_UNIDADES: "veiculos/unidades",
    GET_VEICULOS_ASSOCIAR: "veiculos/associar",
    GET_VEICULOS_DESASSOCIAR: "veiculos/desassociar",
    GET_VEICULOS_VEICULOS_TIPOS: "veiculos/veiculos-tipos",
  },

  VEICULOS_TIPOS: {
    GET_VEICULOS_TIPOS: "veiculos-tipos",
    GET_VEICULOS_TIPOS_VEICULOS: "veiculos-tipos/veiculos",
  },

  GET_USUARIO_BY_ID: "login/getUsuarioAcesso",
  GET_SESSION_TIME: "login/sessiontime",
  POST_LOGIN: "login",
  GET_USUARIO_BY_MATRICULA: "login/matricula",
  GET_USUARIO_ACESSO: "login/getUsuarioAcesso",
  GET_DADOS_USUARIO_BY_MATRICULA: "servidores/matricula",

  //------------POSTAGENS-----------//
  /*
    GET_LAST_POSTAGENS_OS : "ordemServico/getLastPostagensOs",
    GET_POSTAGEM_OLD_PORTAL_BY_ID : "ordemServico/getPostagemOldPortalById",

*/

  /*
   //------------OCORRENCIAS-----------//
   GET_OCORRENCIAS_TESTE : "ocorrencia/getOcorrenciaByProtocoloForMaps20",

*/

  //------------SOLICITAÇÕES-----------//
  GET_OBJETOS_NEW_API: "mapa2api/public/api/teste",
  GET_SOLICITACAO_BY_ID: "mapa2api/public/api/getSolicitacaoById/",
  POST_ANDAMENTO: "mapa2api/public/api/solicitacao",
  GET_AGENTES: "mapa2api/public/api/getAgentes",

  //------------FILTROS-----------//
  GET_LIMITES: "mapa2api/public/api/limites",
  GET_GRUPOS: "mapa2api/public/api/grupos",
  GET_SITUACAO: "mapa2api/public/api/situacao",
};



// WEBPACK FOOTER //
// ./RoutesApi.ts